/// <amd-module name="Artifacts/Package/redux/Contracts" />
import { ComponentState } from "Artifacts/Root/Constants";
import { IPackage, IPackageVersion } from "Artifacts/Root/types";
import { SkeletalPackageVersion } from "Artifacts/Root/types/AzureArtifacts";
import { UpstreamVersionsData } from "Artifacts/Root/types/PackagingShared";
import { IListSelection } from "VSSUI/List";

export interface IPackageDetailsUiState {
  packageDetailsComponentState: ComponentState;
  upstreamVersionsComponentState: ComponentState;
  packageListSelection: IListSelection;
  followState: boolean;
  upstreamOverrideCommandState: ComponentState;
  upstreamOverrideModal: ComponentState;
  upstreamIngestionComponentState: ComponentState;
  upstreamOverrideStatus?: boolean;
}

export interface IPackageDetailsDataState {
  pkg?: IPackage;
  currentPackageVersion?: IPackageVersion;
  packageVersionsList?: SkeletalPackageVersion[];
  upstreamVersionsData?: UpstreamVersionsData;
}

export interface IPackageDetailsState {
  ui: IPackageDetailsUiState;
  data: IPackageDetailsDataState;
}

export interface IPackageDetailsModuleState {
  packageState: IPackageDetailsState;
}
